// extracted by mini-css-extract-plugin
export var blueGhost = "VuYlNG092Kj7ZEc5eREd LtB8VLi_ptQRNKwJA3sW";
export var blueUnderlined = "LtB8VLi_ptQRNKwJA3sW";
export var colourInherit = "JkRsNNT4KFB8sctVYrHc";
export var focusVisible = "LPpUhTUboabiZvFQ__SI";
export var icon = "t3n_3igSJVFLT9lKj_Rb";
export var root = "FqTwczEZGKKQ1Z1EANxZ";